module.exports = __webpack_public_path__ + "assets/media/versus.d3e9773c.mp3";